import { initializeNutasticApp } from '@nutastic/nutastic-react-app';
import { extractElementData, fetchApiData } from '@nutastic/nutastic-react-app/src/utils';
import messages from './i18n/messages';
import App from './App';
import AppLoading from './AppLoading';
import WebFont from 'webfontloader';
import initAppData from "./utils/initAppData.mjs";

const init = async () => {
    WebFont.load({
        google: {
            families: [
                'Poppins:ital,wght@0,100;0,300;0,400;0,600;0,700;0,900;1,100;1,300;1,400;1,600;1,700;1,900'
            ]
        }
    });

    console.log('initializing website');
    await initializeNutasticApp({
        AppComponent: App,
        LoadingComponent: AppLoading,
        initialState: {},
        decorateStateFn: initAppData,
        loadingDelay: 2500,
        messages,
        reducers: []
    });
};

init();
